export const CONSTANTS = {
  features: [
    {
      text: "24/7 proactive monitoring & threat detection.",
    },
    {
      text: "AI-powered security solutions to prevent cyber threats.",
    },
    {
      text: "Dedicated IT Helpdesk support for rapid issue resolution.",
    },
    {
      text: "Customizable & scalable services tailored to business needs.",
    },
    {
      text: "Regulatory compliance management for risk mitigation.",
    },
  ],
  title: "NOC, SOC & Helpdesk Services by OneMind",
  description: [
    "OneMind provides fully managed NOC, SOC, and IT Helpdesk solutions to businesses looking to optimize IT operations, enhance cybersecurity, and provide seamless technical support.",
  ],
  extraContent:
    "Our services ensure that your IT environment remains secure, optimized, and operational at all times.",
};
